import React from "react";
import { useParams } from "react-router-dom";
import ContractForm from "./ContractForm";

export default function EditContract() {
  const params = useParams();
  return <ContractForm contractId={params.id} />;
}
